import React from 'react';

import { EmployeesProps } from './Employees.props';

import EmployeesView from './Employees.view';

const EmployeesContainer = (_: EmployeesProps) => {
  return <EmployeesView />;
};

export default EmployeesContainer;
